export default __webpack_public_path__ + "static/media/photo--sm--hockey2.4e295d7d.jpg";